import React from 'react';
import ReactDOM from 'react-dom';
import { NavLink } from 'react-router-dom';

import cx from 'classnames';
import styles from './styles.scss';

export default class Button extends React.PureComponent {
  static defaultProps = {
    ripple: true,
  };

  onClick = (e, ...args) => {
    if (this.props.ripple && !this.props.active) {
      const el = ReactDOM.findDOMNode(this);

      const button = el.getBoundingClientRect(),
        x = e.clientX - button.left,
        y = e.clientY - button.top;

      const size = Math.sqrt(Math.pow(button.height, 2) + Math.pow(button.width, 2)) * 2;

      const ripple = document.createElement('div');
      ripple.className = cx(styles.ripple, this.props.fillClass);
      ripple.style.height = size + 'px';
      ripple.style.width = size + 'px';
      ripple.style.top = y + 'px';
      ripple.style.left = x + 'px';

      ripple.addEventListener('animationend', () => {
        el.removeChild(ripple);
      });

      setTimeout(() => {
        el.appendChild(ripple);
        requestAnimationFrame(() => ripple.classList.add(styles.active));
      }, 17);
    }

    if (this.props.onClick) {
      this.props.onClick(e, ...args);
    }
  };

  render() {
    const {
      ripple,
      cta,
      fullWidth,
      secondary,
      simple = false,
      fill,
      white,
      fillClass,
      activeClassName,
      active,
      disabled,
      leftAlign,
      ...rest
    } = this.props;
    const props = {
      ...rest,
      onClick: this.onClick,
      className: cx(this.props.className || null, {
        [styles.simple]: simple,
        [styles.secondary]: secondary,
        [styles.fullWidth]: fullWidth,
        [styles.button]: !ripple,
        [styles.rippleButton]: ripple,
        [styles.fillButton]: fill,
        [styles.white]: white,
        [styles.cta]: cta,
        [cx(activeClassName, styles.active)]: active,
        [styles.disabled]: disabled,
        [styles.leftAlign]: leftAlign,
      }),
    };

    const fillElement = fill ? <div className={cx(styles.buttonFill, fillClass)} /> : null;

    let ButtonType = 'a';
    if (this.props.type === 'submit') {
      ButtonType = 'button';
    }

    return this.props.to ? (
      <NavLink {...props} activeClassName={cx(activeClassName, styles.active)}>
        {this.props.children}
        {fillElement}
      </NavLink>
    ) : (
      <ButtonType {...props}>
        {this.props.children}
        {fillElement}
      </ButtonType>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/button/index.js